import { LoadingStates } from '@pb/utils'

import { CybersourceState } from '../types'

export const initialState: CybersourceState = {
  authData: null,
  keyId: null,
  status: LoadingStates.NotLoaded,
}
